/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeMiniReference,
    TapeMiniReferenceFromJSON,
    TapeMiniReferenceFromJSONTyped,
    TapeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeGroupPartialUpdate
 */
export interface TapeGroupPartialUpdate {
    /**
     * 
     * @type {Array<TapeMiniReference>}
     * @memberof TapeGroupPartialUpdate
     */
    tapes?: Array<TapeMiniReference>;
    /**
     * 
     * @type {string}
     * @memberof TapeGroupPartialUpdate
     */
    name?: string;
}

export function TapeGroupPartialUpdateFromJSON(json: any): TapeGroupPartialUpdate {
    return TapeGroupPartialUpdateFromJSONTyped(json, false);
}

export function TapeGroupPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeGroupPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tapes': !exists(json, 'tapes') ? undefined : ((json['tapes'] as Array<any>).map(TapeMiniReferenceFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TapeGroupPartialUpdateToJSON(value?: TapeGroupPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tapes': value.tapes === undefined ? undefined : ((value.tapes as Array<any>).map(TapeMiniReferenceToJSON)),
        'name': value.name,
    };
}


